import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { errorsReducer as errors } from '../../../redux/reducers/errors';
import { sessionReducer as session } from '../../../redux/reducers/session';
import { devicesReducer as devices } from '../../../redux/reducers/devices';
import { eventsReducer as events } from '../../../redux/reducers/events';
import { geofencesReducer as geofences } from '../../../redux/reducers/geofences';
import { groupsReducer as groups } from '../../../redux/reducers/groups';
import { driversReducer as drivers } from '../../../redux/reducers/drivers';
import { maintenancesReducer as maintenances } from '../../../redux/reducers/maintenances';
import { calendarsReducer as calendars } from '../../../redux/reducers/calendars';
import { reportsReducer as reports } from '../../../redux/reducers/reports';
import throttleMiddleware from '../../../redux/reducers/throttleMiddleware';

const reducer = combineReducers({
  errors,
  session,
  devices,
  events,
  geofences,
  groups,
  drivers,
  maintenances,
  calendars,
  reports,
});

export { errorsActions } from '../../../redux/reducers/errors';
export { sessionActions } from '../../../redux/reducers/session';
export { devicesActions } from '../../../redux/reducers/devices';
export { eventsActions } from '../../../redux/reducers/events';
export { geofencesActions } from '../../../redux/reducers/geofences';
export { groupsActions } from '../../../redux/reducers/groups';
export { driversActions } from '../../../redux/reducers/drivers';
export { maintenancesActions } from '../../../redux/reducers/maintenances';
export { calendarsActions } from '../../../redux/reducers/calendars';
export { reportsActions } from '../../../redux/reducers/reports';

export default configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(throttleMiddleware),
});
